import { render, staticRenderFns } from "./QuestionnaireExercise.vue?vue&type=template&id=9ccafad2"
import script from "./QuestionnaireExercise.vue?vue&type=script&lang=js"
export * from "./QuestionnaireExercise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports